import { Select } from "antd";
import React from "react";
import { useSearchParams } from "react-router-dom";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const items = [
  {
    value: "all",
    label: "Tất cả",
  },
  {
    value: "waiting",
    label: "Đang chờ",
  },
  {
    value: "verified",
    label: "Đã duyệt",
  },
  {
    value: "deny",
    label: "Đã từ chối",
  },
];

const KycFilter = () => {
  // -------------------------- VAR -----------------------------
  const [searchParams, setSearchParmas] = useSearchParams();
  const status = searchParams.get("status") || "all";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleChange = (value) => {
    setSearchParmas({ status: value });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Select
      style={{ minWidth: 100, textAlign: "center" }}
      options={items}
      value={status}
      onChange={handleChange}
    />
  );
};
export default KycFilter;
